// extracted by mini-css-extract-plugin
export default {"button":"NewsLinkButton_button__+YYu6","buttonContent":"NewsLinkButton_buttonContent__IJOh2"};